



















































































































import AbpBase from "../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {
	GetWaterMachineList,
	InsertWaterMachine,
	UpdateWaterMachineById,
	DeleteWaterMachine
} from '../../../api/engineer'
import {GetListByCode} from "@/api/configureDictionary"
import Repire from './parts/repair.vue'
import Maintenance from './parts/maintenance.vue'
import Check from './parts/check.vue'
import {GetMachineChangJList, GetMachineModelList} from "@/api/specialDictionary"

@Component({
	components: {Repire, Maintenance, Check}
})
export default class Water extends AbpBase {
	cancel(){
		this.dialogFormVisible = false
	}
	visibleChange(value: boolean) {
		if (!value) {
			this.dialogFormVisible = false;
			(this.$refs.form as any).resetFields()
			this.getData()
		}
	}
	columns = [
		{
			key: 'waterMachineName',
			title: '水处理系统名称'
		},
		{
			key: 'changJ',
			title: '厂家'
		},
		{
			key: 'machineModel',
			title: '型号'
		},
		{
			key: 'je',
			title: '金额'
		},

		{
			key: 'status',
			title: '是否启用',
			render:(h:any, p:any)=>{
				return h('span', p.row.status ? '启用' : '禁用')
			}
		},
		{
			key: 'spare',
			title: '备注'
		},
		{
			key: '',
			width: 320,
			title: '操作',
			render:(h:any, p:any)=>{
				return h('div', [
					h('Button',{
						props:{type: 'primary',size: 'small'},
						style:{marginRight:'10px'},
						on:{
							click:()=>{
								this.repair(p.row)
							}
						}
					},'维修'),
					h('Button',{
						props:{type: 'primary',size: 'small'},
						style:{marginRight:'10px'},
						on:{
							click:()=>{
								this.check(p.row)
							}
						}
					},'检查'),
					h('Button',{
						props:{type: 'primary',size: 'small'},
						style:{marginRight:'10px'},
						on:{
							click:()=>{
								this.maintenance(p.row)
							}
						}
					},'保养'),
					h('Button',{
						props:{type: 'primary',size: 'small'},
						style:{marginRight:'10px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
					h('Button',{
						props:{type: 'error',size: 'small'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),
				])
			}
		},
	]
	key = '' //查询条件
	page = 1 //当前页
	dialogTitle = ''
	dialogForm: any = {}
	dialogFormVisible = false
	dialogFormLabelWidth = '120px'
	tableTotalSize = 0
	tableData = []
	tableLoading = false
	repireShow = false
	maintenanceShow = false
	checkShow = false

	changJs = []  //厂家下拉
	models = []  //型号下拉

	created() {
		this.getData()
		this.getSelects()
	}

	//维修
	repair(row: any) {
		this.dialogForm = Object.assign({}, row)
		this.repireShow = true
	}

	//保养
	maintenance(row: any) {
		this.dialogForm = Object.assign({}, row)
		this.maintenanceShow = true
	}

	//检查
	check(row: any) {
		this.dialogForm = Object.assign({}, row)
		this.checkShow = true
	}

	createCounty() {
		this.dialogTitle = '新增水处理系统'
		this.dialogForm = {status: true, countryWB: '', countryPY: ''}
		this.dialogFormVisible = true
	}

	private async getData() {
		this.tableLoading = true
		let res = await GetWaterMachineList({
			QueryString: this.key,
			SkipCount: this.page,
			MaxResultCount: 10
		})
		this.tableData = res.items
		this.tableTotalSize = res.totalCount
		this.tableLoading = false
	}

	handleClose() {
		this.dialogFormVisible = false
	}

	edit(row: any) {
		this.dialogTitle = '编辑水处理系统'
		this.dialogForm = JSON.parse(JSON.stringify(row))
		this.dialogFormVisible = true
	}

	async del(row: any) {
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteWaterMachine({Id: row.id})
			this.getData()
		}).catch(() => {

		});
	}

	async changJChange(val: any){
		let ChangJID
		this.changJs.forEach((item:any) => {
			if (item.changJ === val) {
				ChangJID = item.id
			}
		})
		let res = await GetMachineModelList({ChangJID: ChangJID})
		this.models = res.items

	}

	async confirm() {
		if (this.dialogTitle === '新增水处理系统') {
			let res = await InsertWaterMachine(this.dialogForm)
		} else if (this.dialogTitle === '编辑水处理系统') {
			let res = await UpdateWaterMachineById(this.dialogForm)
		}
		this.dialogFormVisible = false
		this.getData()
	}

	rules = {
		waterMachineName: [{required: true, message: '请输入内容', trigger: 'blur'}],
		machineModel: [{required: true, message: '请输入内容', trigger: 'blur'}],
		// countryWB:[{required: true, message: '请输入内容', trigger: 'blur'}],
	}

	pageChange(val: any) {
		this.page = val
		this.getData()
	}

	private async getSelects() {
		let res1 = await GetMachineChangJList({})  //生产厂家下拉
		this.changJs = res1.items
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/engineer/waterTreatment/index.vue